import { useParams } from "react-router-dom";
import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import { VehicleDashBoardProvider } from "../vehicles/components/vehicle-dashboard/VehicleDashboard.provider";
import VehicleTransferTable from "./components/vehicleTranferTable";

function VehicleTransferPage() {
  const { licensePlate } = useParams();

  return (
    <ToastProvider>
      <Dashboard>
        <VehicleDashBoardProvider licensePlate={licensePlate || ""}>
          <VehicleTransferTable />
        </VehicleDashBoardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
}

export default VehicleTransferPage;
